import type { GeneratedItem, ItemId } from '@/types/domain';
import { SaveManager } from './SaveManager';

export const GeneratedItemRepository = {
  async all(): Promise<GeneratedItem[]> {
    const items = await SaveManager.allItems();
    return items.sort((a, b) => b.discoveredAt - a.discoveredAt);
  },
  async get(id: ItemId): Promise<GeneratedItem | undefined> {
    return SaveManager.getItem(id);
  },
  async save(item: GeneratedItem): Promise<void> {
    await SaveManager.putItem(item);
  },
  async delete(id: ItemId): Promise<void> {
    await SaveManager.deleteItem(id);
  },
  /** Children = items that use `id` as an ingredient. */
  async childrenOf(id: ItemId): Promise<GeneratedItem[]> {
    const all = await this.all();
    return all.filter((i) => i.ingredientIds.includes(id));
  },
  /** Parents = discovered items used as ingredients of `id`. */
  async parentsOf(item: GeneratedItem): Promise<GeneratedItem[]> {
    const all = await this.all();
    return all.filter((p) => item.ingredientIds.includes(p.id));
  },
  async search(query: string, limit = 100): Promise<GeneratedItem[]> {
    const q = query.trim().toLowerCase();
    const all = await this.all();
    const filtered = q
      ? all.filter(
          (i) =>
            i.name.toLowerCase().includes(q) ||
            i.tags.some((t) => t.includes(q)) ||
            i.category.includes(q) ||
            i.id.toLowerCase().includes(q),
        )
      : all;
    return filtered.slice(0, limit);
  },
};
